<script>import { page } from "../index";
export let data;
const keys = Array.isArray(data) ? data : [data];
$: loaded = keys.every((key) => typeof $page.props[key] !== "undefined");
if (!$$slots.fallback) {
  throw new Error('`<Deferred>` requires a `<svelte:fragment slot="fallback">` slot');
}
</script>

{#if loaded}
  <slot />
{:else}
  <slot name="fallback" />
{/if}
